/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var IdCardIcon32Regular = forwardRef('IdCardIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 12a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H9Zm0 2h4v4H9v-4Z" }),
        React.createElement("path", { d: "M17 14a1 1 0 0 1 1-1h6.5a1 1 0 1 1 0 2H18a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M18 17a1 1 0 1 0 0 2h6.5a1 1 0 1 0 0-2H18Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 5A5.5 5.5 0 0 0 2 10.5v11A5.5 5.5 0 0 0 7.5 27h17a5.5 5.5 0 0 0 5.5-5.5v-11A5.5 5.5 0 0 0 24.5 5h-17ZM4 10.5A3.5 3.5 0 0 1 7.5 7h17a3.5 3.5 0 0 1 3.5 3.5v11a3.5 3.5 0 0 1-3.5 3.5h-17A3.5 3.5 0 0 1 4 21.5v-11Z" })));
});
